var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7804 3.21936C20.8502 3.28903 20.9056 3.3718 20.9435 3.46291C20.9813 3.55403 21.0007 3.65171 21.0007 3.75036C21.0007 3.84902 20.9813 3.9467 20.9435 4.03781C20.9056 4.12893 20.8502 4.2117 20.7804 4.28136L4.28039 20.7814C4.13956 20.9222 3.94855 21.0013 3.74939 21.0013C3.55022 21.0013 3.35922 20.9222 3.21839 20.7814C3.07756 20.6405 2.99844 20.4495 2.99844 20.2504C2.99844 20.0512 3.07756 19.8602 3.21839 19.7194L19.7184 3.21936C19.7881 3.14952 19.8708 3.09411 19.9619 3.0563C20.0531 3.01849 20.1507 2.99902 20.2494 2.99902C20.348 2.99902 20.4457 3.01849 20.5368 3.0563C20.628 3.09411 20.7107 3.14952 20.7804 3.21936Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21839 3.21936C3.14854 3.28903 3.09313 3.3718 3.05532 3.46291C3.01751 3.55403 2.99805 3.65171 2.99805 3.75036C2.99805 3.84902 3.01751 3.9467 3.05532 4.03781C3.09313 4.12893 3.14854 4.2117 3.21839 4.28136L19.7184 20.7814C19.8592 20.9222 20.0502 21.0013 20.2494 21.0013C20.4486 21.0013 20.6396 20.9222 20.7804 20.7814C20.9212 20.6405 21.0003 20.4495 21.0003 20.2504C21.0003 20.0512 20.9212 19.8602 20.7804 19.7194L4.28039 3.21936C4.21072 3.14952 4.12796 3.09411 4.03684 3.0563C3.94572 3.01849 3.84804 2.99902 3.74939 2.99902C3.65074 2.99902 3.55305 3.01849 3.46194 3.0563C3.37082 3.09411 3.28806 3.14952 3.21839 3.21936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLarge);
export default __webpack_public_path__ + "static/media/x-large.b04c9e7bc77f4808f8fc804ce219aaa9.svg";
export { ForwardRef as ReactComponent };